<template>
  <div id="app">
    <div class="flex" :class="isMobile ? 'flex-col' : 'flex-row'">
      <NavigationComponent :isOpen="isOpen" :toggleMenu="toogleMenu" :closeMenu="closeMenu"/>

      <div class="w-full transition-all duration-300"
           :class="[
               isOpen ? 'animate-slide-right-in-margin' : 'animate-slide-right-out-margin',
               isMobile ? '!m-0 !mt-16': ''
              ]">
        <router-view />
      </div>
    </div>
    <AnimatedList id="notifications" class="absolute top-0 right-0 flex flex-col items-end justify-end">
      <NotificationComponent v-for="notification of notificationStore.notifications" :id="notification.id"
                           :message="notification.message" :type="notification.type" :key="notification.id"/>
    </AnimatedList>
  </div>
</template>

<script setup>

import NotificationComponent from "@/components/molecules/NotificationComponent.vue";
import {NotificationStores} from "@/stores/NotificationStores";
import NavigationComponent from "@/components/organismes/NavigationComponent.vue";
import {ref} from "vue";
import AnimatedList from "@/components/molecules/AnimatedList.vue";

const notificationStore = NotificationStores();

const isMobile = ref(window.innerWidth < 768);
const drawerNavigationName = 'drawer-navigation';
const isOpenPreviously = localStorage.getItem(drawerNavigationName);

if(!isOpenPreviously) {
  localStorage.setItem(drawerNavigationName, !isMobile.value);
}

const isOpen = ref(localStorage.getItem(drawerNavigationName) === 'true');


const toogleMenu = () => {
  isOpen.value = !isOpen.value;
  localStorage.setItem(drawerNavigationName, isOpen.value);
}

const closeMenu = () => {
  isOpen.value = false
  localStorage.setItem(drawerNavigationName, 'false');
}

</script>

<style>
:root {
  background-color: #f5f5f5;
}
</style>
